import { useQueryClient } from '@tanstack/react-query';
import React, { FC, useEffect } from 'react';

import { WebToRNAction, postMessageRN, runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { StandardButton } from '@eika/button';
import { Modal, ModalDialogProps } from '@eika/modal';

import piwik from '@/piwik/piwik';

import { SearchParams, useSearchParam } from '@domain/app';
import { useSigningResultListener } from '@domain/signing';
import useText from '@hooks/use-text';

import './BankIdModal.scss';

interface Props extends ModalDialogProps {
    show: boolean;
    redirectUri: string;
    dynamicLinkId: string;
}

const BankIdModal: FC<Props> = ({ redirectUri, dynamicLinkId, setOpen, id, appNamespace, ...rest }) => {
    useSigningResultListener();
    const text = useText();
    const queryClient = useQueryClient();
    const accountId = useSearchParam(SearchParams.ACCOUNT_ID);

    useEffect(() => {
        if (runningInRNWebView && dynamicLinkId && redirectUri) {
            postMessageRN({
                action: WebToRNAction.SIGN,
                payload: { bankIdUri: redirectUri, dynamicLinkId },
            });
        }
    }, [dynamicLinkId, redirectUri]);

    const closeSigning = () => {
        queryClient.resetQueries({
            queryKey: ['v4', 'credit-card-account', accountId],
        });
        setOpen(false);
    };

    if (!runningInRNWebView) {
        return (
            <Modal
                id={id}
                appNamespace={appNamespace}
                setOpen={setOpen}
                {...rest}
                data-track-id={piwik.transfer.transferBankIdModal.dataTrackId}
                data-track-linkname={piwik.transfer.transferBankIdModal.dataTrackLinkname}
            >
                <div className="bank-id-modal">
                    <h2>BankId Signering</h2>
                    <iframe
                        className="bank-id-signing__iframe"
                        height="325"
                        src={redirectUri}
                        title="Signering"
                        width="325"
                    />
                    <div className="footer-container">
                        <StandardButton
                            data-track-id={piwik.transfer.transferCancel.dataTrackId}
                            data-track-linkname={piwik.transfer.transferCancel.dataTrackLinkname}
                            id="transfer-cancel"
                            onClick={closeSigning}
                        >
                            {text.formClose}
                        </StandardButton>
                    </div>
                </div>
            </Modal>
        );
    }

    return <></>;
};

export default BankIdModal;
